import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const getAllSupplier = (name) => {
  return Api(
    `${endPoints.getAllSupplier}?businessName=${name || ""}&limit=${500}`,
    null,
    requestType.GET
  );
};

export { getAllSupplier };
